export const PROCESS_IMPROVEMENT_WIDGETS = {
  wipAge: { title: 'Work in progress age', description: 'Analysis of how long work has been in progress', row: 2 },
  ct: { title: 'Cycle time', description: 'Analysis of cycle time patterns and deviations', row: 1 },
  th: { title: 'Throughput', description: 'Analysis of delivery rate and throughput trends', row: 1 },
  wip: { title: 'Work in progress', description: 'Analysis of current work load and capacity', row: 1 },
  ctb: { title: 'Cycle time per process step', description: 'Analysis of time spent in each workflow stage', row: 2 },
  fe: { title: 'Flow efficiency', description: 'Analysis of work time vs wait time efficiency', row: 2 },
};

export const PROCESS_IMPROVEMENT_WIDGETS_SMALL = {
  wipAge: { title: 'Work in progress age', description: 'Analysis of how long work has been in progress', row: 2 },
  ct: { title: 'Cycle time', description: 'Analysis of cycle time patterns and deviations', row: 1 },
  th: { title: 'Throughput', description: 'Analysis of delivery rate and throughput trends', row: 1 },
  wip: { title: 'Work in progress', description: 'Analysis of current work load and capacity', row: 2 },
  ctb: { title: 'Cycle time per process step', description: 'Analysis of time spent in each workflow stage', row: 3 },
  fe: { title: 'Flow Efficiency', description: 'Analysis of work time vs wait time efficiency', row: 3 },
};


export const PROCESS_IMPROVEMENT_WIDGETS_ARRAY = Object.entries(PROCESS_IMPROVEMENT_WIDGETS).map(([id, props]) => ({
  value: id,
  label: props.title,
  _id: id,
  description: props.description || '',
}));

export const PROCESS_IMPROVEMENT_WIDGET_IDS = Object.keys(PROCESS_IMPROVEMENT_WIDGETS);
